import React, { useEffect, useState } from 'react';
import api from './api';

/**
 * OAuth callback for GetLate (Late API). Late redirects here after user connects
 * Instagram/TikTok. We call the backend to save the account id on the workspace.
 * URL: /getlate/callback?workspaceId=...&platform=instagram|tiktok
 */
export default function GetLateCallback() {
    const [status, setStatus] = useState('loading'); // 'loading' | 'done' | 'error'
    const [message, setMessage] = useState('');

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const workspaceId = params.get('workspaceId');
        const platform = params.get('platform');

        if (!workspaceId || !platform) {
            setStatus('error');
            setMessage('Missing workspaceId or platform in URL.');
            return;
        }

        api.finalizeGetLateConnection(workspaceId, platform)
            .then(() => {
                setStatus('done');
                setMessage(`${platform} connected for this workspace. You can close this window.`);
                try {
                    window.setTimeout(() => window.close(), 2500);
                } catch (_) {}
            })
            .catch((err) => {
                setStatus('error');
                setMessage(err.response?.data?.error || err.message || 'Failed to save connection.');
            });
    }, []);

    return (
        <div style={{
            padding: 24,
            fontFamily: 'system-ui, sans-serif',
            maxWidth: 360,
            margin: '40px auto',
            textAlign: 'center'
        }}>
            {status === 'loading' && <p>Saving connection…</p>}
            {status === 'done' && <p style={{ color: 'green' }}>{message}</p>}
            {status === 'error' && <p style={{ color: 'red' }}>{message}</p>}
        </div>
    );
}
